// table.tsx
import { Table } from "../../features/Table";
import { type MacroKeyword, macro_keyword_columns } from "./columns";
import { FilterMacroKeyword } from "./filter";
import { useLocation } from "react-router-dom";

const client = "ia-quantilia";
const table_name = "macro_keywords";

export const MacroKeywordsTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;

  return (
    <Table<MacroKeyword, MacroKeyword>
      label="Macro Keywords"
      client={client}
      table_name={table_name}
      columns={macro_keyword_columns}
      disable_translations_request={true}
      filter={<FilterMacroKeyword />}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
